import { Link } from 'react-router-dom';
import { formatReservationDate } from '../util/formatReservationDate';
import React from 'react';

const carInfo = {
  carNumber: '10버 0834',
  carName: '그랜저 XG',
  carYear: '1999년식',
  carScale:'승용',
  carRegion: '',
  carReservationDate: ["2025-01-04T11:00:00+09:00", "2025-01-20T14:00:00+09:00"],
  carRepairPart: ['앞펜더(우)', 'A필러(우)', '뒷문(우)', '뒤펜더(우)'],
  userName: '김윤진',
  userPhoneNumber: '010-1234-4567',
  userRequest: ''
}

const businessInfo = {
  name: "한국공업사",
  branch: "20년 경력의 1급 정비소",
  address: "서울특별시 강남구",
  phone: "02-000-0000",
  bookingNumber: "0000-0000"
}


const Finished = () => {

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <div className="px-4 py-3">
        <h1 className="text-lg font-semibold text-center">다이렉트보상</h1>
      </div>

      {/* Main Content */}
      <div className="flex-1 px-4">
        {/* Success Message */}
        <div className="flex flex-col items-center mt-8">
          <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-slate-700">
            <img src="/assets/img/finish.jpg" alt="check" />
          </div>
          <h2 className="mb-1 text-2xl font-bold">예약이 완료되었습니다!</h2>
          <p className="text-center text-[#46474C]">수리 예약을 맡겨주셔서 감사합니다.</p>
        </div>

        {/* Business Card */}
        <div className="mt-6 overflow-hidden  rounded-lg shadow-[0px_0px_16px_rgba(0,0,0,0.08)]">
          <img 
            src="/assets/img/place.jpg" 
            alt="업체 전경"
            className="object-cover w-full h-48"
          />
          <div className="p-4">
            <h3 className="text-[20px] font-bold">{businessInfo.name}</h3>
            <p className="mt-1 text-[#46474C]">{businessInfo.branch}</p>

            <div className="pt-4 mt-4 text-sm text-gray-600 border-t border-[#EAEBEC]">
              <div className="flex items-start gap-2">
                <img src="/assets/img/ico_info.svg" alt="img" />
                <span className='text-[15px]'><b>{businessInfo.bookingNumber}</b>번호로 <b>안내 전화</b>를 드리고,<br />
                <b>알림톡</b>으로 확인 메세지를 보내드립니다.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Button */}
      <div className="p-4 mt-auto">
        <Link to="/" className="flex items-center justify-center w-full py-4 font-medium text-white rounded-lg bg-slate-800">
          완료
        </Link>
      </div>
    </div>
  );
};

export default Finished;